import { Controller } from "@hotwired/stimulus"
import { dsConfirm } from "../../utils/ds_confirm";

export default class extends Controller {
  static targets = ["selectAll", "item", "regenerateBtn", "selectedCount"]
  static values = {
    url: String,
    confirmMessage: String,
    regenerateLabel: String,
  }

  connect() {
    this.updateState()
  }

  disconnect() {
    // Reset indeterminate state on select-all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.indeterminate = false
    }
  }

  toggleAll() {
    const isChecked = this.selectAllTarget.checked

    this.itemTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })

    this.updateState()
  }

  toggleItem() {
    this.updateState()
  }

  updateState() {
    const totalItems = this.itemTargets.length
    const checkedItems = this.itemTargets.filter(cb => cb.checked).length

    // Update select-all checkbox state
    if (this.hasSelectAllTarget) {
      if (checkedItems === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (checkedItems === totalItems) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }

    // Update button state
    if (this.hasRegenerateBtnTarget) {
      const btn = this.regenerateBtnTarget
      if (checkedItems === 0) {
        btn.disabled = true
        btn.classList.add('opacity-50', 'cursor-not-allowed')
        btn.classList.remove('btn-cta')
        btn.classList.add('btn-disabled')
      } else {
        btn.disabled = false
        btn.classList.remove('opacity-50', 'cursor-not-allowed')
        btn.classList.remove('btn-disabled')
        btn.classList.add('btn-cta')
      }
    }

    // Update counter badge
    if (this.hasSelectedCountTarget) {
      if (checkedItems > 0) {
        this.selectedCountTarget.textContent = checkedItems
        this.selectedCountTarget.classList.remove('hidden')
      } else {
        this.selectedCountTarget.classList.add('hidden')
      }
    }
  }

  async submitRegenerate(event) {
    event.preventDefault()

    const selectedIds = this.itemTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (selectedIds.length === 0) return

    const message = this.confirmMessageValue
      .replace('%{count}', selectedIds.length)

    if (!(await dsConfirm(message))) return

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.urlValue

    // CSRF token
    const csrfMeta = document.querySelector(
      'meta[name="csrf-token"]'
    )
    if (csrfMeta) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfMeta.getAttribute('content')
      form.appendChild(csrfInput)
    }

    // Add each selected payslip ID
    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'payslip_ids[]'
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
